// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__302BQ","boxTitle":"Qualiphy_boxTitle__3m6hc","box":"Qualiphy_box__2lm0O","toggleWrap":"Qualiphy_toggleWrap__2XCut"};